import React from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';
import styles from './TextEditor.module.css'
import { environment } from '../../../config.env';

function TextEditor({
    value = '',
    setValue = () => { },
    placeholder = '',
    label = '',
    readOnly = false
}) {

    const ENDPOINT_DOMAIN = environment.endpoint_domain || ''

    const handleImageUpload = (file) => {
        const formData = new FormData();
        formData.append('image', file);
        return fetch(ENDPOINT_DOMAIN+'/api/v1/admin/content/uploadFileContent', {
          method: 'POST',
          body: formData,
        })
        .then(response => response.json())
        .then(data => data.url);  // Assume the server returns the image URL
    };

    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' },
            { 'indent': '-1' }, { 'indent': '+1' }],
            ['link', 'image'],
            ['clean']
        ],
        //imageHandler: handleImageUpload,  // Custom image upload handler
        clipboard: {
            // toggle to add extra line breaks when pasting HTML:
            matchVisual: true,
        }
        
    }


    const getStyle = (readOnly) => {
        if (readOnly) {
            return {
                borderColor: '#A2B5BC',
                borderWidth: 1,
                borderRadius: 15,
                height: 400
            }
        } else {
            return {}
        }
    }


    return (
        <div>
            {label ? <div className={styles.label}>{label}</div> : null}
            <ReactQuill
                style={getStyle(readOnly)}
                theme={readOnly ? 'bubble' : 'snow'}
                readOnly={readOnly}
                placeholder={placeholder}
                value={value}
                onChange={setValue}
                modules={modules}
            />
        </div>

    )
}

export default TextEditor